import _ from 'lodash';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {
  buildReminderValueForCalendarEventVersionReminder,
  calendarReminderUnitToText,
} from '../../../../srcCommon/helpers/calendarReminderHelpers';
import {CalendarEventVersionReminder} from '../../../models/api/calendarEventVersionModel';

/*
 * Props.
 */

export interface CalendarRemindersViewerProps {
  reminders: ReadonlyArray<CalendarEventVersionReminder>;
}

/*
 * Styles.
 */

const StyledWrapperDiv = styled.div`
  line-height: 21px;
`;

/*
 * Component.
 */

export const CalendarRemindersViewer: FC<CalendarRemindersViewerProps> = (props) => {
  const sortedReminderValues = _(props.reminders)
    .sortBy((r) => r.minutesBefore)
    .map(buildReminderValueForCalendarEventVersionReminder)
    .value();

  return (
    <StyledWrapperDiv>
      {sortedReminderValues.map((r) => (
        <div key={`calendar-reminders-viewer-${r.unit}-${r.count}`}>
          {r.count} {calendarReminderUnitToText[r.unit]} <Trans id="calendar-reminder-before">before</Trans>
        </div>
      ))}
    </StyledWrapperDiv>
  );
};
